import React from "react";
import "./RegalInputComponents.scss"

const RegalTextArea = ({ label, value, onChange, placeholder, required, error, errorText, disable }) => {


    return (
        <div className="RegalInputComponents-RegalDefault">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`RegalInputComponents-RegalDefault-container ${error ? "error" : disable ? "disable" : ""}`}>
                <textarea
                    className="RegalInputComponents-RegalDefault-container-textareanew"
                    value={value}
                    onChange={onChange}
                    type="text"
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default RegalTextArea